module.exports = __webpack_public_path__ + "img/ger_true_gem.7641b0d8.png";